export default "__VITE_ASSET__KyGqO8pP__"